import { DataGrid } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IconButton, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { SET_PROJECT } from 'store/actions';
import { formatAmount } from 'utils/StringFormats';
import { StateChips } from 'utils/StateChips';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';

const ProjectTable = forwardRef(({ projects: rows }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const columns = [
    { field: 'sequence', headerName: '# Solicitud', flex: 1, minWidth: 120 },
    { field: 'title', headerName: 'Título', flex: 2 },
    {
      field: 'presupuestoRequerido',
      headerName: 'Presupuesto',
      flex: 1,
      renderCell: (params) => params.row.presupuestoRequerido && `$ ${formatAmount(params.row.presupuestoRequerido)}`
    },
    {
      field: 'responsable',
      headerName: 'Solicitado por',
      flex: 2,
      renderCell: (params) => params.row?.responsable?.displayName
    },
    { field: 'asignadoA', headerName: 'Asignado a', flex: 1, renderCell: (params) => params.row?.asignadoA?.displayName },
    {
      field: 'status',
      headerName: 'Estado',
      flex: 1,
      renderCell: (params) => <Tooltip title={params.row.status}>{StateChips(params.row.status)}</Tooltip>
    },
    { field: 'created', headerName: 'Fecha de solicitud', flex: 2 },
    { field: 'updated', headerName: 'Ultima revisión', flex: 2, sortComparator: (v1, v2) => dayjs(v1).unix() - dayjs(v2).unix() },
    {
      field: 'action',
      headerName: 'Ver',
      flex: 1,
      renderCell: (params) => (
        <Tooltip title="Ver Detalle Proyecto">
          <IconButton color="primary" onClick={() => viewDetail(params.row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const viewDetail = (project) => {
    dispatch({ type: SET_PROJECT, project });
    navigate('/detail-project');
  };

  const exportToExcel = () => {
    const data = rows.map((row) => ({
      '# Solicitud': row.sequence,
      Título: row.title,
      Presupuesto: row.presupuestoRequerido ? `$ ${formatAmount(row.presupuestoRequerido)}` : '',
      'Solicitado por': row.responsable?.displayName || '',
      'Asignado a': row.asignadoA?.displayName || '',
      Estado: row.status,
      'Fecha de solicitud': row.created,
      'Ultima revisión': row.updated
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Projects');

    XLSX.writeFile(workbook, 'Projects.xlsx');
  };

  useImperativeHandle(ref, () => ({
    exportToExcel
  }));

  return (
    <div style={{ minHeight: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        sortModel={[
          {
            field: 'updated',
            sort: 'desc'
          }
        ]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 15
            }
          }
        }}
        pageSizeOptions={[1, 5, 10, 15, 25, 50]}
        disableRowSelectionOnClick
      />
    </div>
  );
});

export default ProjectTable;
